import './Loader.css'; // Import the CSS file

const Loader = () => {
  return <div className="loader"></div>; // Updated class name
};

export default Loader;
